import CompanyCell from './CompanyCell';
import TextCell from './TextCell';

export const SORTING = {
  NAME: 'NAME',
  LASTNAME: 'LASTNAME',
  EMAIL: 'EMAIL',
  MOBILE: 'MOBILE',
  COMPANY: 'COMPANY',
};

export const ORDER = {
  NORMAL: 'NORMAL',
  INVERSE: 'INVERSE',
};

export const TABLE_COLUMNS = [
  {
    Header: 'Name',
    accessor: 'name',
    items: [
      {
        action: {
          type: 'name-alphabetical',
        },
        icon: 'alphabet',
        name: 'Sort name',
      },
      {
        action: {
          type: 'lastname-alphabetical',
        },
        icon: 'alphabet',
        name: 'Sort last name',
      },
    ],
    renderComponent: {
      component: TextCell,
      value: 'value',
    },
    width: 150,
    minWidth: 100,
    maxWidth: 2000,
  },
  {
    Header: 'Email',
    accessor: 'email',
    items: [
      {
        action: {
          type: 'email-alphabetical',
        },
        icon: 'alphabet',
        name: 'Sort email',
      },
    ],
    renderComponent: {
      component: TextCell,
      value: 'value',
    },
    width: 250,
    minWidth: 100,
    maxWidth: 2000,
  },
  {
    Header: 'Phone',
    accessor: 'mobile',
    items: [
      {
        action: {
          type: 'mobile-alphabetical',
        },
        icon: 'alphabet',
        name: 'Sort mobile',
      },
    ],
    renderComponent: {
      component: TextCell,
      value: 'value',
    },
    width: 150,
    minWidth: 150,
    maxWidth: 150,
  },
  {
    Header: 'Company',
    accessor: 'company',
    subAccessors: ['cid'],
    items: [
      {
        action: {
          type: 'company-alphabetical',
        },
        icon: 'alphabet',
        name: 'Sort company',
      },
    ],
    renderComponent: {
      component: CompanyCell,
      value: 'companyName',
      optionalProps: ['cid'],
    },
    width: 280,
    minWidth: 100,
    maxWidth: 2000,
  },
];

export const DEFAULT_COLUMN = {
  minWidth: 80,
  width: 200,
  maxWidth: 400,
};

export const HIGHLIGHT_PROPS = {
  highlightClassName: 'text-turquoise-300 bg-transparent',
  autoEscape: true,
};
